// TwoFASetup.jsx
import React from "react";
import { QRCodeSVG } from "qrcode.react";

export const theme = {
  bg: "#131313",
  panel: "#030504",
  text: "#e6eaf2",
  muted: "#b0b0b0",
  primary: "#4bb390",
  accent: "#22d3ee",
  danger: "#ef4444",
  radius: 16,
  border: "1px solid var(--border-color)",
};

const Wrap = (s) => Object.assign({ boxSizing: "border-box" }, s);

export default function TwoFASetup({
  otpauth,
  secret,
  onContinue,
  onBack,
  message,
}) {
  const [copied, setCopied] = React.useState(false);

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(secret.replace(/\s+/g, ""));
      setCopied(true);
      setTimeout(() => setCopied(false), 1500);
    } catch {
      setCopied(false);
    }
  };

  return (
    <div
      style={Wrap({
        background: theme.bg,
        color: theme.text,
        fontFamily: "Inter, system-ui, sans-serif",
        display: "grid",
        placeItems: "center",
        padding: 24,
        border: theme.border,
        borderRadius: 24,
      })}
    >
      <section
        style={Wrap({
          width: "min(720px, 100%)",
          background: theme.panel,
          borderRadius: 24,
          border: "1px solid rgba(255,255,255,.06)",
          padding: 24,
          boxShadow: "0 10px 40px rgba(0,0,0,.45)",
        })}
      >
        <h1 style={Wrap({ margin: "4px 0 8px", fontSize: 26 })}>
          Two‑Factor Authentication Setup
        </h1>
        <p style={Wrap({ color: theme.muted, margin: "0 0 18px" })}>
          {message ||
            "Scan the QR code with an authenticator app to enable 2FA."}
        </p>

        <div
          style={Wrap({
            display: "grid",
            justifyContent: "center",
            padding: "12px 0 8px",
          })}
        >
          <div
            style={Wrap({
              background: "#fff",
              borderRadius: 16,
              padding: 18,
              border: "1px solid rgba(255,255,255,.06)",
            })}
          >
            <QRCodeSVG
              value={otpauth}
              size={192}
              level="M"
              bgColor="#FFFFFF"
              fgColor="#000000"
              includeMargin={false}
              style={Wrap({ display: "block" })}
            />
          </div>
        </div>

        <p
          style={Wrap({
            color: theme.muted,
            textAlign: "center",
            margin: "12px 0 18px",
          })}
        >
          Works with Google Authenticator, Authy, or any TOTP app.
        </p>

        <div
          style={Wrap({
            background: "#111317",
            borderRadius: 16,
            padding: 16,
            border: "1px solid rgba(255,255,255,.08)",
          })}
        >
          <h3 style={Wrap({ margin: "0 0 8px", fontSize: 16 })}>
            Manual Setup
          </h3>
          <p style={Wrap({ color: theme.muted, margin: "0 0 12px" })}>
            If QR scanning fails, enter this code manually.
          </p>

          <div
            style={Wrap({
              display: "grid",
              gridTemplateColumns: "1fr auto",
              gap: 12,
              alignItems: "center",
              background: "#0b0d10",
              borderRadius: 12,
              padding: 10,
              border: "1px solid rgba(255,255,255,.06)",
            })}
          >
            <code
              style={Wrap({
                color: "#8fb3ff",
                whiteSpace: "pre-wrap",
                wordBreak: "break-word",
                padding: "6px 8px",
                lineHeight: 1.4,
              })}
            >
              {secret}
            </code>

            <button
              onClick={copy}
              style={Wrap({
                background: theme.primary,
                color: "#06110d",
                border: "1px solid rgba(0,0,0,.25)",
                borderRadius: 10,
                padding: "10px 16px",
                fontWeight: 700,
                cursor: "pointer",
                minWidth: 96,
              })}
            >
              {copied ? "Copied" : "Copy"}
            </button>
          </div>
        </div>

        <div
          style={Wrap({
            display: "flex",
            justifyContent: "center",
            gap: 14,
            marginTop: 18,
            flexWrap: "wrap",
          })}
        >
          {onBack && (
            <button
              onClick={onBack}
              style={Wrap({
                background: "#111317",
                color: theme.text,
                border: "1px solid rgba(255,255,255,.08)",
                borderRadius: 12,
                padding: "12px 18px",
                minWidth: 140,
                cursor: "pointer",
              })}
            >
              Back
            </button>
          )}

          <button
            onClick={onContinue}
            style={Wrap({
              background: theme.primary,
              color: "#fff",
              borderRadius: 12,
              padding: "12px 18px",
              border: "1px solid rgba(0,0,0,.25)",
              cursor: "pointer",
              minWidth: 200,
            })}
          >
            Continue to Verification
          </button>
        </div>
      </section>
    </div>
  );
}
